import ApiClient from "../api/ApiClient";
import UploadedFile from "../../model/UploadedFile";

export default class FilesDao {
    private apiClient: ApiClient;

    constructor(apiClient: ApiClient) {
        this.apiClient = apiClient;
    }

    public upload(file: File): Promise<UploadedFile> {
        return this.apiClient.files.post(file)
            .then(response => response.data);
    }
}